import * as Sentry from '@sentry/react';

declare const __APP_RELEASE__: string;

const SENTRY_DSN = typeof import.meta !== 'undefined' ? (import.meta.env.VITE_SENTRY_DSN as string | undefined) : undefined;
const APP_ENV = typeof import.meta !== 'undefined' ? (import.meta.env.VITE_APP_ENV as string | undefined) : undefined;
const APP_RELEASE =
  typeof import.meta !== 'undefined'
    ? ((import.meta.env.VITE_APP_RELEASE as string | undefined) || __APP_RELEASE__)
    : __APP_RELEASE__;

export function initMonitoring(): boolean {
  const dsn = String(SENTRY_DSN || '').trim();
  if (!dsn) return false;
  Sentry.init({
    dsn,
    environment: APP_ENV || import.meta.env.MODE || 'production',
    release: APP_RELEASE || 'local',
    tracesSampleRate: 0.05,
    beforeSend(event) {
      delete event.request?.cookies;
      delete event.request?.headers?.authorization;
      return event;
    },
  });
  return true;
}

export const MonitoringErrorBoundary = Sentry.ErrorBoundary;
